import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

export const createQueryParameters = (requestParameters: {
  offset?: number;
  limit?: number;
  filters?: any;
  sort?: any;
  [key: string]: any;
}) => {
  const queryParameters: {[key: string]: any} = {
    ...requestParameters,
  };

  if (requestParameters.offset !== undefined) {
    queryParameters.offset = requestParameters.offset;
  }

  if (requestParameters.limit !== undefined) {
    queryParameters.limit = requestParameters.limit;
  }

  if (requestParameters.filters !== undefined) {
    queryParameters.filters = requestParameters.filters;
  }

  if (requestParameters.sort !== undefined) {
    queryParameters.sort = requestParameters.sort;
  }

  return omitBy(queryParameters, isNil);
};
